// import { useContext, useEffect, useState } from "react";
// import { getMe } from "../../resources/api";
// import { cn } from "../../utils/utils";
// import Modal from "../common/Modal";
// import Button from "../common/Button";
// import { useNavigate } from "react-router-dom";
// import UserContext from "../../context/UserContext";

// const ModuleChoice = ({ onNext }) => {
//   const [ct, setCt] = useState();
//   const [fluency, setFluency] = useState();
//   const [grade, setGrade] = useState();
//   const [allowCt, setAllowCt] = useState(true);
//   const [canTakeCT, setCanTakeCT] = useState(true);
//   const navigate = useNavigate()
//   const [isFluencyLocked, setIsFluencyLocked] = useState(false)
//   const { setUser } = useContext(UserContext)
//   useEffect(() => {
//     getMe().then((res) => {
//       setUser(res.data)
//       // if(res.data.grade === 3){
//       //   setAllowCt(false)
//       // }

//       const isInPretest = res?.data.progresses?.find(a => (!a.hasPassed && a.lessonId === 0))
//       console.log({ isInPretest, res })
//       if (isInPretest) {
//         return navigate("/lessons/0")
//       }
//       if (res.data?.assignable) {
//         navigate("/assignable")
//         return
//       }

//       if (res.data?.dyslexia && res.data?.userType !== "trainee") {
//         navigate("/dyslexia")
//         return
//       }
//       setIsFluencyLocked(res.data?.accountLocked)
//       const currentLesson =
//         res.data.currentLesson >= 1
//           ? `Lesson ${res.data.currentLesson}`
//           : "Pre Test";
//       setFluency(currentLesson);
//       setGrade(res.data.grade);
//       setCt(res.data.ctProgresses);
//       setCanTakeCT(res.data.canTakeCT !== false);
//       const license_type = res.data.license?.license_type;
//       if (license_type) {
//         if (license_type === "ct") {
//           onNext("critical");
//         }
//         if (license_type === "fl") {
//           onNext("fluency");
//         }
//         if (license_type === "lb") {
//           onNext("library");
//         }
//       }
//       const passedLesson21 = res.data?.progresses?.find(
//         (p) => p.lessonId === 21 && p.hasPassed,
//       );

//       if (
//         !res.data?.pretestPassed &&
//         !passedLesson21 &&
//         !res.data?.ctProgresses
//       ) {
//         setAllowCt(false);
//       }
//     });
//     soundManager.cleanAllChannel();
//   }, []);

//   const [openModal, setOpenModal] = useState(false);
//   return (
//     <div className=" fixed top-0 left-0 w-screen h-screen overflow-hidden flex bg-white z-50">
//       <div className="flex flex-col lg:flex-row gap-4 lg:gap-6 py-6 lg:py-10 w-full px-4 lg:px-6">
//         <div
//           className="w-full flex-1 cursor-pointer relative min-h-[250px] sm:min-h-[300px] lg:min-h-[500px]"
//           onClick={() => {
//             if (fluency && !isFluencyLocked) {
//               onNext("fluency");
//             }
//           }}
//         >

//           {isFluencyLocked && (
//             <svg
//               className="absolute left-[42%] z-10 top-[40%]"
//               xmlns="http://www.w3.org/2000/svg"
//               width="9em"
//               height="9em"
//               viewBox="0 0 24 24"
//             >
//               <path
//                 fill="currentColor"
//                 d="M6.616 21q-.667 0-1.141-.475T5 19.386v-8.77q0-.666.475-1.14T6.615 9H8V7q0-1.671 1.165-2.835Q10.329 3 12 3t2.836 1.165T16 7v2h1.385q.666 0 1.14.475t.475 1.14v8.77q0 .666-.475 1.14t-1.14.475zM12 16.5q.633 0 1.066-.434q.434-.433.434-1.066t-.434-1.066T12 13.5t-1.066.434Q10.5 14.367 10.5 15t.434 1.066q.433.434 1.066.434M9 9h6V7q0-1.25-.875-2.125T12 4t-2.125.875T9 7z"
//               ></path>
//             </svg>
//           )}
//           <div
//             style={{
//               background: `url("/gradient-blue.png")`,
//               backgroundRepeat: "no-repeat",
//               backgroundPosition: "center",
//             }}
//             className={cn("h-full min-h-[250px] sm:min-h-[300px] lg:min-h-[500px] flex flex-col items-center justify-between py-4 sm:py-6 lg:py-10 lg:!bg-contain bg-cover rounded-xl", isFluencyLocked && "grayscale blur-sm brightness-75 opacity-80")}
//           >
//             <div className="flex flex-col flex-grow justify-center items-center px-4">
//               <svg
//                 width="198"
//                 height="198"
//                 className="w-12 h-12 sm:w-16 sm:h-16 md:w-24 md:h-24 lg:w-32 lg:h-32 xl:w-[196px] xl:h-[196px]"
//                 viewBox="0 0 198 198"
//                 fill="none"
//                 xmlns="http://www.w3.org/2000/svg"
//               >
//                 <path
//                   d="M99 166.939L173.25 156.333V32.8309L101.623 43.065C99.8833 43.3134 98.1167 43.3134 96.3765 43.065L24.75 32.8309V156.333L99 166.939ZM26.4949 20.5796L98.1214 30.8138C98.7041 30.8974 99.2959 30.8974 99.8786 30.8138L171.505 20.5796C173.26 20.3297 175.048 20.4597 176.748 20.9607C178.448 21.4618 180.021 22.3223 181.36 23.4839C182.699 24.6456 183.773 26.0813 184.508 27.6939C185.244 29.3065 185.625 31.0583 185.625 32.8309V156.333C185.625 159.313 184.55 162.193 182.597 164.443C180.644 166.694 177.945 168.164 174.995 168.585L99.8786 179.314C99.2959 179.397 98.7041 179.397 98.1214 179.314L23.0051 168.585C20.0552 168.164 17.3558 166.694 15.403 164.443C13.4502 162.193 12.375 159.313 12.375 156.333V32.8309C12.375 31.0583 12.7558 29.3065 13.4916 27.6939C14.2274 26.0813 15.3011 24.6456 16.6399 23.4839C17.9788 22.3223 19.5515 21.4618 21.2518 20.9607C22.952 20.4597 24.74 20.3297 26.4949 20.5796Z"
//                   fill="#6948B1"
//                 />
//                 <path
//                   d="M92.8125 37.125H105.188V173.25H92.8125V37.125Z"
//                   fill="#6948B1"
//                 />
//               </svg>
//               <p className="text-sm sm:text-lg md:text-2xl lg:text-3xl xl:text-4xl font-bold text-purple-900 text-center">
//                 Reading Fluency
//               </p>
//               <p className="text-xs sm:text-base md:text-lg font-medium text-center">{fluency}</p>
//             </div>
//             <button className=" bg-[#6948B1] px-3 sm:px-4 py-2 sm:py-2 md:py-3 rounded-xl sm:rounded-2xl text-white text-sm sm:text-base md:text-xl lg:text-2xl font-medium flex items-center justify-between gap-2 sm:gap-4 shadow-md shadow-[#A47C7C]">
//               <span className="font-bold">Continue</span>
//               <svg
//                 className="w-2 h-3 md:w-4 md:h-5"
//                 viewBox="0 0 13 22"
//                 fill="none"
//                 xmlns="http://www.w3.org/2000/svg"
//               >
//                 <path
//                   d="M8.15 11L0.675001 3.52499C0.323612 3.1736 0.147919 2.72638 0.147919 2.18332C0.147919 1.64027 0.323612 1.19305 0.675001 0.841658C1.02639 0.490269 1.47361 0.314575 2.01667 0.314575C2.55972 0.314575 3.00695 0.490269 3.35834 0.841658L12.175 9.65833C12.3667 9.84999 12.5028 10.0576 12.5833 10.2812C12.6638 10.5049 12.7034 10.7444 12.7021 11C12.7021 11.2555 12.6625 11.4951 12.5833 11.7187C12.504 11.9424 12.3679 12.15 12.175 12.3417L3.35834 21.1583C3.00695 21.5097 2.55972 21.6854 2.01667 21.6854C1.47361 21.6854 1.02639 21.5097 0.675001 21.1583C0.323612 20.8069 0.147919 20.3597 0.147919 19.8167C0.147919 19.2736 0.323612 18.8264 0.675001 18.475L8.15 11Z"
//                   fill="white"
//                 />
//               </svg>
//             </button>
//           </div>
//         </div>

//         <div
//           className="w-full flex-1 relative cursor-pointer min-h-[250px] sm:min-h-[300px] lg:min-h-[500px]"
//           onClick={() => {
//             if (grade) {
//               // if (grade && allowCt) {
//               onNext("library");
//             } else {
//               setOpenModal(true);
//             }
//           }}
//         >

//           <div
//             style={{
//               background: `url("/gradient-library.png")`,
//               backgroundRepeat: "no-repeat",
//               backgroundPosition: "center",
//             }}
//             className={cn(
//               "h-full min-h-[250px] sm:min-h-[300px] lg:min-h-[500px] flex flex-col items-center justify-between py-4 sm:py-6 lg:py-10 lg:!bg-contain bg-cover relative rounded-xl",
//               // Library module is currently disabled/not ready - applying blur 
//               // "grayscale blur-sm brightness-75 opacity-80",
//             )}
//           >
//             {/* <div className="flex-1 h-[800px] p-8 rounded-[40px] flex flex-col justify-between items-center gradient-orange shadow-lg"> */}
//             <div className="flex flex-col items-center justify-center w-full px-2 sm:px-4">
//               <h3 className="text-sm sm:text-lg md:text-2xl lg:text-3xl xl:text-4xl font-bold text-center">
//                 <span className="text-[#1A588A]">Welcome To </span>
//                 <span className="text-[#1A588A]">Read </span>
//                 <span className="text-[#439C56]">21</span>
//               </h3>
//             </div>

//             <div className="w-12 h-12 sm:w-16 sm:h-16 md:w-24 md:h-24 lg:w-32 lg:h-32 xl:w-36 xl:h-36 flex items-center justify-center mb-1 sm:mb-2 md:mb-3">

//               <img src="/library.png" alt="Gold Gradient" className="w-full h-auto " />


//               {/* <svg className="w-full h-full" viewBox="0 0 226 216" fill="none">
//                   <rect x="20" y="40" width="180" height="140" rx="10" fill="#3D74B6" stroke="#374957" strokeWidth="2"/>
//                   <rect x="30" y="50" width="160" height="100" fill="white"/>
//                   <rect x="40" y="60" width="30" height="80" fill="#4A90E2"/>
//                   <rect x="80" y="60" width="30" height="80" fill="#4A90E2"/>
//                   <rect x="120" y="60" width="30" height="80" fill="#4A90E2"/>
//                   <rect x="160" y="60" width="20" height="80" fill="#4A90E2"/>
//                   <circle cx="113" cy="200" r="15" fill="#B4E50D"/>
//                 </svg> */}
//             </div>

//             {/* <div className="rounded-3xl flex flex-col items-center justify-center w-full text-center relative"> */}
//             <div className="rounded-2xl sm:rounded-3xl flex flex-col items-center justify-center w-full max-w-xs sm:max-w-sm mx-auto text-center relative p-2 sm:p-3 md:p-4 bg-white/10 shadow-lg">
//               <h4 className="text-sm sm:text-lg md:text-xl lg:text-2xl font-bold text-[#374957] mb-1 md:mb-2">Online Library</h4>
//               {/* <div className="flex items-center justify-center gap-2 mt-2">
//                   <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
//                     <g clip-path="url(#clip0_254_943)">
//                       <path d="M19 2.4319C18.5315 2.04018 17.9825 1.75639 17.392 1.60071C16.8015 1.44502 16.184 1.42124 15.5833 1.53107L12.3983 2.1094C11.663 2.24444 10.9944 2.62276 10.5 3.18357C10.0043 2.62179 9.33377 2.24338 8.59664 2.1094L5.41664 1.53107C4.81593 1.42115 4.19841 1.44461 3.60778 1.5998C3.01715 1.75499 2.46786 2.03811 1.99877 2.42911C1.52969 2.82012 1.15229 3.30946 0.893288 3.86249C0.634285 4.41552 0.50001 5.01873 0.499969 5.6294L0.499969 14.6236C0.500017 15.5992 0.84245 16.5439 1.46758 17.293C2.09271 18.0421 2.96089 18.5481 3.9208 18.7227L9.15914 19.6752C10.0458 19.8363 10.9542 19.8363 11.8408 19.6752L17.0833 18.7227C18.0424 18.5472 18.9097 18.0409 19.534 17.2919C20.1583 16.5429 20.5001 15.5986 20.5 14.6236V5.6294C20.5003 5.01894 20.3661 4.4159 20.1069 3.86323C19.8476 3.31056 19.4697 2.82185 19 2.4319V2.4319ZM9.66664 18.0694C9.59664 18.0594 9.52664 18.0477 9.45664 18.0352L4.21914 17.0836C3.64311 16.9788 3.12213 16.6751 2.74704 16.2256C2.37195 15.776 2.16655 15.2091 2.16664 14.6236V5.6294C2.16664 4.96636 2.43003 4.33048 2.89887 3.86164C3.36771 3.39279 4.0036 3.1294 4.66664 3.1294C4.81754 3.12976 4.96813 3.14343 5.11664 3.17024L8.29997 3.75357C8.68298 3.82365 9.02936 4.02563 9.27901 4.32444C9.52865 4.62325 9.66579 5.00003 9.66664 5.3894V18.0694ZM18.8333 14.6236C18.8334 15.2091 18.628 15.776 18.2529 16.2256C17.8778 16.6751 17.3568 16.9788 16.7808 17.0836L11.5433 18.0352C11.4733 18.0477 11.4033 18.0594 11.3333 18.0694V5.3894C11.3332 4.99908 11.4702 4.62111 11.7202 4.32141C11.9703 4.0217 12.3176 3.81927 12.7016 3.7494L15.8858 3.16607C16.2464 3.10046 16.617 3.11494 16.9714 3.20849C17.3258 3.30204 17.6553 3.47237 17.9365 3.70741C18.2177 3.94244 18.4438 4.23645 18.5988 4.56859C18.7538 4.90073 18.8338 5.26288 18.8333 5.6294V14.6236Z" fill="#374957" />
//                     </g>
//                     <defs>
//                       <clipPath id="clip0_254_943">
//                         <rect width="20" height="20" fill="white" transform="translate(0.499969 0.629395)" />
//                       </clipPath>
//                     </defs>
//                   </svg>

//                   <span className="text-xl text-[#374957]">Doing Your Best</span>
//                 </div> */}


//               <div className="flex flex-wrap justify-center gap-2 sm:gap-3 md:gap-4 lg:gap-5 mb-2 w-full">
//                 {[1, 2, 3, 4, 5, 6, 7, 8].map((d) => {
//                   return (
//                     <div className={
//                       d === 6 && grade < 9 && grade >= 6
//                         ? "w-6 h-6 sm:w-8 sm:h-8 md:w-10 md:h-10 lg:w-12 lg:h-12 bg-gradient-to-b  from-[#3D74B6] to-[#3D74B6] rounded-full flex items-center justify-center"
//                         : grade >= 9 && d === 7
//                           ? "w-6 h-6 sm:w-8 sm:h-8 md:w-10 md:h-10 lg:w-12 lg:h-12 bg-gradient-to-b  from-[#3D74B6] to-[#3D74B6] rounded-full flex items-center justify-center"
//                           : d === grade && grade <= 5
//                             ? "w-6 h-6 sm:w-8 sm:h-8 md:w-10 md:h-10 lg:w-12 lg:h-12 bg-gradient-to-b  from-[#3D74B6] to-[#3D74B6] rounded-full flex items-center justify-center"
//                             : "w-6 h-6 sm:w-8 sm:h-8 md:w-10 md:h-10 lg:w-12 lg:h-12 bg-gradient-to-b  from-[#B4E50D] to-[#78C841] rounded-full flex items-center justify-center"
//                     }>
//                       <span className={`font-medium text-xs sm:text-sm md:text-base lg:text-lg ${d === 6 && grade < 9 && grade >= 6
//                         ? "text-white"
//                         : grade >= 9 && d === 7
//                           ? "text-white"
//                           : d === grade && grade <= 5
//                             ? "text-white"
//                             : "text-[#374957]"
//                         } `}>
//                         {/* {d < 6 ? `G${d}` : d === 6 ? "MS" : "HS"} */}
//                         {`G${d}`}
//                       </span>
//                     </div>
//                   );
//                 })}
//                 {/* <div className="w-20 h-20 bg-gradient-to-b from-[#B4E50D] to-[#78C841] rounded-full flex items-center justify-center">
//                   <span className="text-[#374957] font-medium text-xl">1st</span>
//                 </div>
//                 <div className="w-[91px] h-[91px] bg-[#3D74B6] rounded-full flex items-center justify-center">
//                   <span className="text-white font-medium text-2xl">2nd</span>
//                 </div>
//                 <div className="w-20 h-20 bg-gradient-to-b from-[#B4E50D] to-[#78C841] rounded-full flex items-center justify-center">
//                   <span className="text-[#374957] font-medium text-xl">3rd</span>
//                 </div>
//                 <div className="w-20 h-20 bg-gradient-to-b from-[#B4E50D] to-[#78C841] rounded-full flex items-center justify-center">
//                   <span className="text-[#374957] font-medium text-xl">4th</span>
//                 </div>
//                 <div className="w-20 h-20 bg-gradient-to-b from-[#B4E50D] to-[#78C841] rounded-full flex items-center justify-center">
//                   <span className="text-[#374957] font-medium text-xl">5th</span>
//                 </div>
//                 <div className="w-20 h-20 bg-gradient-to-b from-[#B4E50D] to-[#78C841] rounded-full flex items-center justify-center">
//                   <span className="text-[#374957] font-medium text-xl">6th</span>
//                 </div>
//                 <div className="w-20 h-20 bg-gradient-to-b from-[#B4E50D] to-[#78C841] rounded-full flex items-center justify-center">
//                   <span className="text-[#374957] font-medium text-xl">7th</span>
//                 </div>
//                 <div className="w-20 h-20 bg-gradient-to-b from-[#B4E50D] to-[#78C841] rounded-full flex items-center justify-center">
//                   <span className="text-[#374957] font-medium text-xl">8th</span>
//                 </div> */}
//               </div>
//             </div>

//             <button onClick={() => navigate('/libraryIntro')} className=" bg-[#3D74B6] px-3 sm:px-4 py-2 sm:py-2 md:py-3 rounded-xl sm:rounded-2xl text-white text-sm sm:text-base md:text-xl lg:text-2xl font-medium flex items-center justify-between gap-2 sm:gap-4 shadow-md shadow-[#A47C7C]">
//               <span className="font-bold">Continue</span>
//               <svg
//                 className="w-2 h-3 md:w-4 md:h-5"
//                 viewBox="0 0 13 22"
//                 fill="none"
//                 xmlns="http://www.w3.org/2000/svg"
//               >
//                 <path
//                   d="M8.15 11L0.675001 3.52499C0.323612 3.1736 0.147919 2.72638 0.147919 2.18332C0.147919 1.64027 0.323612 1.19305 0.675001 0.841658C1.02639 0.490269 1.47361 0.314575 2.01667 0.314575C2.55972 0.314575 3.00695 0.490269 3.35834 0.841658L12.175 9.65833C12.3667 9.84999 12.5028 10.0576 12.5833 10.2812C12.6638 10.5049 12.7034 10.7444 12.7021 11C12.7021 11.2555 12.6625 11.4951 12.5833 11.7187C12.504 11.9424 12.3679 12.15 12.175 12.3417L3.35834 21.1583C3.00695 21.5097 2.55972 21.6854 2.01667 21.6854C1.47361 21.6854 1.02639 21.5097 0.675001 21.1583C0.323612 20.8069 0.147919 20.3597 0.147919 19.8167C0.147919 19.2736 0.323612 18.8264 0.675001 18.475L8.15 11Z"
//                   fill="white"
//                 />
//               </svg>
//             </button>
//             {/* <button
//                 onClick={() => navigate('/library-entrance')}
//                 className="w-full md:w-1/2 py-3 md:py-4 bg-[#3D74B6] text-white rounded-3xl text-xl md:text-2xl font-bold shadow-button hover:bg-[#2d5a94] transition-all"
//               >
//                 Continue
//               </button> */}
//             {/* </div> */}
//           </div>
//         </div>

//         <div
//           className="w-full flex-1 relative cursor-pointer min-h-[250px] sm:min-h-[300px] lg:min-h-[500px]"
//           onClick={() => {
//             if (grade && allowCt && canTakeCT) {
//               onNext("critical");
//             } else {
//               setOpenModal(true);
//             }
//           }}
//         >
//           {allowCt && !canTakeCT && (
//             <div className="absolute left-[42%] z-10 top-[40%] bg-white rounded-full p-3 shadow-lg">
//               <svg
//                 xmlns="http://www.w3.org/2000/svg"
//                 width="5em"
//                 height="5em"
//                 viewBox="0 0 24 24"
//                 className="text-orange-500"
//               >
//                 <path
//                   fill="currentColor"
//                   d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm.5-13H11v6l5.25 3.15.75-1.23-4.5-2.67V7z"
//                 />
//               </svg>
//             </div>
//           )}
//           <div
//             style={{
//               background: `url("/gradient-gold.png")`,
//               backgroundRepeat: "no-repeat",
//               backgroundPosition: "center",
//             }}
//             className={cn(
//               "h-full min-h-[250px] sm:min-h-[300px] lg:min-h-[500px] flex flex-col items-center justify-between py-4 sm:py-6 lg:py-10 lg:!bg-contain bg-cover relative rounded-xl",
//               !allowCt && "grayscale blur-sm brightness-75 opacity-80",
//             )}
//           >
//             <div className="flex relative flex-col flex-grow justify-center items-center px-2 sm:px-4">
//               <svg
//                 className="w-12 h-12 sm:w-16 sm:h-16 md:w-24 md:h-24 lg:w-32 lg:h-32 xl:w-[196px] xl:h-[196px]"
//                 viewBox="0 0 196 196"
//                 fill="none"
//                 xmlns="http://www.w3.org/2000/svg"
//               >
//                 <path
//                   d="M58.408 24.598C65.2027 19.306 74.088 16.3823 82.9162 16.3823C88.2 16.3823 92.4712 18.1953 95.7133 21.0782C96.5872 21.854 97.363 22.6952 98.0572 23.5608C98.7513 22.6952 99.5272 21.854 100.401 21.0782C103.643 18.1953 107.914 16.3823 113.198 16.3823C122.026 16.3823 130.92 19.306 137.698 24.598C142.99 28.7058 147.131 34.3817 148.756 41.2335C152.186 41.8052 155.232 43.5528 157.698 45.864C161.618 49.5472 164.419 54.8718 166.175 60.3517C167.964 65.9132 168.854 72.1607 168.585 78.1632C168.446 81.2338 167.997 84.3698 167.139 87.367L167.67 87.612C170.691 89.033 173.142 91.2625 174.979 94.227C178.45 99.8212 179.675 107.873 179.675 118.139C179.675 129.94 175.159 137.951 169.36 142.925C166.34 145.515 162.805 147.436 158.989 148.56C157.604 154.942 154.758 160.915 150.675 166.012C144.771 173.395 135.591 179.634 123.26 179.634C113.378 179.634 105.595 174.162 100.597 168.936C99.7106 168.002 98.8659 167.029 98.0653 166.02C97.2619 167.026 96.4145 167.996 95.5255 168.927C90.5275 174.17 82.7447 179.634 72.863 179.634C60.5232 179.634 51.3438 173.395 45.4475 166.012C41.3583 160.917 38.5069 154.943 37.1175 148.56C33.3037 147.435 29.7716 145.514 26.754 142.925C20.9557 137.943 16.4477 129.94 16.4477 118.139C16.4477 107.873 17.6727 99.8212 21.1353 94.227C22.9725 91.1813 25.7127 88.7836 28.9753 87.367C28.1363 84.3659 27.6511 81.277 27.5298 78.1632C27.2603 72.1607 28.1505 65.9132 29.939 60.3517C31.6948 54.88 34.4878 49.5472 38.416 45.864C40.8728 43.4693 43.985 41.8578 47.3585 41.2335C48.9918 34.3735 53.1242 28.7058 58.408 24.598ZM65.9377 34.2592C61.4787 37.73 58.8653 42.3523 58.8653 47.677C58.8646 48.647 58.6335 49.6029 58.191 50.4662C57.7486 51.3294 57.1074 52.0752 56.3204 52.6421C55.5333 53.2091 54.6229 53.581 53.664 53.7273C52.7051 53.8736 51.7251 53.79 50.8048 53.4835C49.686 53.1078 48.5018 53.1977 46.8032 54.7983C44.9085 56.5705 42.9893 59.78 41.601 64.092C40.2122 68.4599 39.5932 73.036 39.7717 77.616C39.9758 82.1567 41.0538 85.9296 42.7525 88.4777C43.0336 88.8998 43.2612 89.3552 43.4303 89.8333H52.2667C58.1464 89.8321 63.8087 92.0562 68.1157 96.0587C72.4228 100.061 75.0554 105.546 75.4845 111.41C79.0026 112.813 81.9234 115.396 83.747 118.716C85.5707 122.036 86.1838 125.887 85.4814 129.609C84.779 133.331 82.8048 136.693 79.8967 139.12C76.9886 141.547 73.3274 142.888 69.5397 142.913C65.752 142.938 62.0733 141.646 59.1332 139.258C56.1932 136.87 54.1746 133.534 53.4228 129.821C52.6711 126.109 53.2331 122.251 55.0125 118.907C56.7919 115.563 59.6782 112.942 63.1773 111.491C62.7894 108.875 61.4741 106.486 59.4712 104.759C57.4683 103.032 54.9113 102.082 52.2667 102.083H30.8292C29.6042 104.925 28.6977 109.833 28.6977 118.139C28.6977 126.477 31.7275 131.05 34.7328 133.631C38.024 136.449 41.6418 137.184 42.6872 137.184C44.3116 137.184 45.8695 137.829 47.0182 138.978C48.1669 140.126 48.8122 141.684 48.8122 143.309C48.8122 146.739 50.7068 152.97 55.0188 158.36C59.1675 163.562 65.0802 167.384 72.863 167.384C78.0652 167.384 82.8508 164.46 86.6647 160.475C88.5103 158.531 89.9477 156.514 90.895 154.881C91.2535 154.27 91.5674 153.634 91.8342 152.978L91.8832 152.864V75.5417H84.5658C83.1444 79.0555 80.5451 81.9656 77.2134 83.7732C73.8818 85.5807 70.0251 86.1733 66.3045 85.4492C62.5838 84.7252 59.2308 82.7297 56.8201 79.8046C54.4094 76.8795 53.0911 73.2071 53.0911 69.4167C53.0911 65.6262 54.4094 61.9538 56.8201 59.0287C59.2308 56.1037 62.5838 54.1081 66.3045 53.3841C70.0251 52.66 73.8818 53.2526 77.2134 55.0602C80.5451 56.8677 83.1444 59.7778 84.5658 63.2917H91.8832V42.5647L91.8587 42.0992C91.7189 39.584 91.224 37.1012 90.3887 34.7247C89.6537 32.7647 88.6982 31.2375 87.5712 30.233C86.5667 29.3347 85.1783 28.6323 82.9162 28.6323C76.6605 28.6323 70.462 30.7393 65.9295 34.2673M104.239 138.833V152.864L104.28 152.978C104.443 153.411 104.754 154.056 105.228 154.881C106.167 156.514 107.604 158.531 109.458 160.475C113.263 164.46 118.057 167.384 123.26 167.384C131.034 167.384 136.947 163.562 141.104 158.36C145.408 152.97 147.31 146.73 147.31 143.309C147.31 141.684 147.956 140.126 149.104 138.978C150.253 137.829 151.811 137.184 153.435 137.184C154.481 137.184 158.09 136.449 161.39 133.631C164.387 131.05 167.417 126.477 167.417 118.139C167.417 108.274 166.126 103.194 164.566 100.687C164.078 99.8198 163.338 99.1219 162.443 98.686C161.618 98.294 160.377 98 158.458 98C157.349 97.9999 156.262 97.699 155.311 97.1293C154.36 96.5596 153.581 95.7424 153.058 94.765C152.535 93.7876 152.287 92.6866 152.34 91.5793C152.394 90.4721 152.747 89.4001 153.362 88.4777C155.061 85.9296 156.139 82.1567 156.351 77.616C156.526 73.0356 155.905 68.4595 154.513 64.092C153.125 59.78 151.206 56.5787 149.319 54.7983C147.613 53.1977 146.428 53.1078 145.318 53.4835C144.397 53.7916 143.416 53.8764 142.456 53.7309C141.496 53.5854 140.584 53.2137 139.796 52.6466C139.008 52.0794 138.366 51.333 137.923 50.469C137.48 49.6049 137.249 48.6479 137.249 47.677C137.249 42.3523 134.636 37.73 130.177 34.2592C125.66 30.7393 119.454 28.6242 113.19 28.6242C110.936 28.6242 109.556 29.3347 108.543 30.2248C107.265 31.4787 106.302 33.0181 105.734 34.7165C104.818 37.2355 104.313 39.8854 104.239 42.5647V126.583H109.433C112.357 126.583 115.162 125.422 117.229 123.354C119.297 121.287 120.458 118.482 120.458 115.558V100.899C116.944 99.4777 114.034 96.8785 112.227 93.5468C110.419 90.2151 109.827 86.3585 110.551 82.6378C111.275 78.9171 113.27 75.5642 116.195 73.1535C119.12 70.7427 122.793 69.4244 126.583 69.4244C130.374 69.4244 134.046 70.7427 136.971 73.1535C139.896 75.5642 141.892 78.9171 142.616 82.6378C143.34 86.3585 142.747 90.2151 140.94 93.5468C139.132 96.8785 136.222 99.4777 132.708 100.899V115.558C132.708 121.731 130.256 127.651 125.891 132.016C121.526 136.381 115.606 138.833 109.433 138.833H104.239ZM69.4167 65.3333C68.3337 65.3333 67.2951 65.7635 66.5293 66.5293C65.7635 67.2951 65.3333 68.3337 65.3333 69.4167C65.3333 70.4996 65.7635 71.5382 66.5293 72.304C67.2951 73.0698 68.3337 73.5 69.4167 73.5C70.4996 73.5 71.5382 73.0698 72.304 72.304C73.0698 71.5382 73.5 70.4996 73.5 69.4167C73.5 68.3337 73.0698 67.2951 72.304 66.5293C71.5382 65.7635 70.4996 65.3333 69.4167 65.3333ZM65.3333 126.583C65.3333 127.666 65.7635 128.705 66.5293 129.471C67.2951 130.236 68.3337 130.667 69.4167 130.667C70.4996 130.667 71.5382 130.236 72.304 129.471C73.0698 128.705 73.5 127.666 73.5 126.583C73.5 125.5 73.0698 124.462 72.304 123.696C71.5382 122.93 70.4996 122.5 69.4167 122.5C68.3337 122.5 67.2951 122.93 66.5293 123.696C65.7635 124.462 65.3333 125.5 65.3333 126.583ZM122.5 85.75C122.5 86.833 122.93 87.8716 123.696 88.6373C124.462 89.4031 125.5 89.8333 126.583 89.8333C127.666 89.8333 128.705 89.4031 129.471 88.6373C130.236 87.8716 130.667 86.833 130.667 85.75C130.667 84.667 130.236 83.6284 129.471 82.8626C128.705 82.0969 127.666 81.6667 126.583 81.6667C125.5 81.6667 124.462 82.0969 123.696 82.8626C122.93 83.6284 122.5 84.667 122.5 85.75Z"
//                   fill="#FFA800"
//                 />
//               </svg>
//               <p className="text-sm sm:text-lg md:text-2xl lg:text-3xl xl:text-4xl font-bold text-gold-900 text-center">
//                 Critical Thinking
//               </p>
//               <p className="text-xs sm:text-base md:text-lg font-medium text-center">{ct || "Not Started"}</p>
//               <div className="flex items-center gap-1 sm:gap-2 md:gap-3 justify-center mt-2 sm:mt-4 md:mt-6">
//                 {[2, 3, 4, 5, 6, 7].map((d) => {
//                   return (
//                     <div
//                       className={cn(
//                         "w-5 h-5 sm:w-6 sm:h-6 md:w-8 md:h-8 lg:w-10 lg:h-10 bg-white border-2 border-yellow-400 rounded-full flex items-center justify-center font-bold text-gray-400",
//                         d === 6 && grade < 9 && grade >= 6
//                           ? "bg-yellow-500 text-white"
//                           : grade >= 9 && d === 7
//                             ? "bg-yellow-500 text-white"
//                             : d === grade && grade <= 5
//                               ? "bg-yellow-500 text-white"
//                               : "",
//                       )}
//                     >
//                       <span className="text-xs sm:text-xs md:text-sm">{d < 6 ? `G${d}` : d === 6 ? "MS" : "HS"}</span>
//                     </div>
//                   );
//                 })}
//               </div>
//             </div>
//             <button className=" bg-[#FFA800] px-3 sm:px-4 py-2 sm:py-2 md:py-3 rounded-xl sm:rounded-2xl text-white text-sm sm:text-base md:text-xl lg:text-2xl font-medium flex items-center justify-between gap-2 sm:gap-4 shadow-md shadow-[#A47C7C]">
//               <span className="font-bold">Continue</span>
//               <svg
//                 className="w-2 h-3 md:w-4 md:h-5"
//                 viewBox="0 0 13 22"
//                 fill="none"
//                 xmlns="http://www.w3.org/2000/svg"
//               >
//                 <path
//                   d="M8.15 11L0.675001 3.52499C0.323612 3.1736 0.147919 2.72638 0.147919 2.18332C0.147919 1.64027 0.323612 1.19305 0.675001 0.841658C1.02639 0.490269 1.47361 0.314575 2.01667 0.314575C2.55972 0.314575 3.00695 0.490269 3.35834 0.841658L12.175 9.65833C12.3667 9.84999 12.5028 10.0576 12.5833 10.2812C12.6638 10.5049 12.7034 10.7444 12.7021 11C12.7021 11.2555 12.6625 11.4951 12.5833 11.7187C12.504 11.9424 12.3679 12.15 12.175 12.3417L3.35834 21.1583C3.00695 21.5097 2.55972 21.6854 2.01667 21.6854C1.47361 21.6854 1.02639 21.5097 0.675001 21.1583C0.323612 20.8069 0.147919 20.3597 0.147919 19.8167C0.147919 19.2736 0.323612 18.8264 0.675001 18.475L8.15 11Z"
//                   fill="white"
//                 />
//               </svg>
//             </button>
//           </div>
//         </div>
//       </div>
//       {openModal && (
//         <Modal className="" close={() => setOpenModal(false)}>
//           <div className="bg-white rounded-2xl px-10 py-4">
//             {!canTakeCT && allowCt ? (
//               <div className="flex flex-col items-center justify-center p-8">
//                 <div className="mb-6">
//                   <img
//                     src="/images/alarm_clock.jpg"
//                     alt="Alarm Clock"
//                     className="w-32 h-32 mx-auto"
//                   />
//                 </div>
//                 <div className="bg-gray-100 rounded-2xl p-6 text-center max-w-md">
//                   <h2 className="text-3xl font-bold text-gray-800 mb-4">SEE YOU TOMORROW FOR YOUR NEXT LESSON.</h2>
//                 </div>
//                 <Button
//                   className="mt-6"
//                   onClick={() => setOpenModal(false)}
//                   background="blue"
//                   title="OK"
//                 />
//               </div>
//             ) : (
//               <div>
//                 <div className="flex items-center justify-center">
//                   <svg
//                     xmlns="http://www.w3.org/2000/svg"
//                     className="text-red-600"
//                     width="3em"
//                     height="3em"
//                     viewBox="0 0 24 24"
//                   >
//                     <path
//                       fill="currentColor"
//                       d="m12 13.4l-4.9 4.9q-.275.275-.7.275t-.7-.275t-.275-.7t.275-.7l4.9-4.9l-4.9-4.9q-.275-.275-.275-.7t.275-.7t.7-.275t.7.275l4.9 4.9l4.9-4.9q.275-.275.7-.275t.7.275t.275.7t-.275.7L13.4 12l4.9 4.9q.275.275.275.7t-.275.7t-.7.275t-.7-.275z"
//                     ></path>
//                   </svg>
//                   <p className="text-3xl text-red-700 font-bold">Access Denied</p>
//                 </div>
//                 <p className="text-2xl text-black break-words max-w-screen-sm mt-3 text-center">
//                   Complete Reading Fluency or have Teacher Unlock.
//                 </p>
//                 <div className="flex justify-center mt-4">
//                   <Button
//                     onClick={() => {
//                       onNext("fluency");
//                     }}
//                     contentSize="medium"
//                     title="Continue to Reading Fluency"
//                     icon={"nextBack"}
//                   />
//                 </div>
//               </div>
//             )}
//           </div>
//         </Modal>

//       )}

//     </div>
//   );
// };

// export default ModuleChoice;

import { useContext, useEffect, useState } from "react";
import { getMe } from "../../resources/api";
import { cn } from "../../utils/utils";
import Modal from "../common/Modal";
import Button from "../common/Button";
import { useNavigate } from "react-router-dom";
import UserContext from "../../context/UserContext";

const ModuleChoice = ({ onNext }) => {
  const [ct, setCt] = useState();
  const [fluency, setFluency] = useState();
  const [grade, setGrade] = useState();
  const [allowCt, setAllowCt] = useState(true);
  const [canTakeCT, setCanTakeCT] = useState(true);
  const [canTakeLibrary, setCanTakeLibrary] = useState(true);
  const [libraryLockReason, setLibraryLockReason] = useState(null);
  const [isLibraryOnlyLicense, setIsLibraryOnlyLicense] = useState(false);
  const navigate = useNavigate()
  const [isFluencyLocked, setIsFluencyLocked] = useState(false)
  const { setUser } = useContext(UserContext)
  useEffect(() => {
    getMe().then((res) => {
      setUser(res.data)
      // if(res.data.grade === 3){
      //   setAllowCt(false)
      // }

      const isInPretest = res?.data.progresses?.find(a => (!a.hasPassed && a.lessonId === 0))
      console.log({ isInPretest, res })
      if (isInPretest) {
        return navigate("/lessons/0")
      }
      if (res.data?.assignable) {
        navigate("/assignable")
        return
      }

      if (res.data?.dyslexia && res.data?.userType !== "trainee") {
        navigate("/dyslexia")
        return
      }
      setIsFluencyLocked(res.data?.accountLocked)
      const currentLesson =
        res.data.currentLesson >= 1
          ? `Lesson ${res.data.currentLesson}`
          : "Pre Test";
      setFluency(currentLesson);
      setGrade(res.data.grade);
      setCt(res.data.ctProgresses);
      setCanTakeCT(res.data.canTakeCT !== false);
      // For library, check multiple conditions:
      // 1. If canAccessLibrary is explicitly false (from backend), lock it
      // 2. If latestQuizTaken is true (took quiz within 4 hours), lock it
      // 3. Otherwise, allow access
      const canAccessLibrary = res.data.canAccessLibrary !== false;
      const quizLocked = res.data.latestQuizTaken === true;
      const lesson28Locked = res.data.libraryLockReason === "lesson28";

      setCanTakeLibrary(canAccessLibrary && !quizLocked && !lesson28Locked);
      // Set lock reason - prioritize lesson28, then quiz, otherwise null
      setLibraryLockReason(
        res.data.libraryLockReason === "lesson28"
          ? "lesson28"
          : quizLocked
            ? "quiz"
            : null
      );
      const license_type = res.data.license?.license_type;
      if (license_type) {
        if (license_type === "ct") {
          onNext("critical");
        }
        if (license_type === "fl") {
          onNext("fluency");
        }
        if (license_type === "library") {
          setIsLibraryOnlyLicense(true);
          // For library-only license, only check quiz lock (lesson28 doesn't apply)
          // Update canTakeLibrary to only check quiz lock for library-only users
          setCanTakeLibrary(canAccessLibrary && !quizLocked);
          // Set lock reason - only quiz applies for library-only users
          setLibraryLockReason(quizLocked ? 'quiz' : null);

          if (canAccessLibrary && !quizLocked && res.data.grade) {
            onNext("library");
          } else {
            // If library is locked, show the lock modal
            setModalType('library');
            setOpenModal(true);
          }
        }
      }
      const passedLesson21 = res.data?.progresses?.find(
        (p) => p.lessonId === 21 && p.hasPassed,
      );

      if (
        !res.data?.pretestPassed &&
        !passedLesson21 &&
        !res.data?.ctProgresses
      ) {
        setAllowCt(false);
      }
    });
    soundManager.cleanAllChannel();
  }, []);

  const [openModal, setOpenModal] = useState(false);
  const [modalType, setModalType] = useState('ct'); // 'ct' or 'library'
  return (
    <div className=" fixed top-0 left-0 w-screen h-screen overflow-hidden flex bg-white z-50">
      <div className="flex flex-col lg:flex-row gap-4 lg:gap-6 py-6 lg:py-10 w-full px-4 lg:px-6">
        {!isLibraryOnlyLicense && (
          <div
            className="w-full flex-1 cursor-pointer relative min-h-[250px] sm:min-h-[300px] lg:min-h-[500px]"
            onClick={() => {
              if (fluency && !isFluencyLocked) {
                onNext("fluency");
              }
            }}
          >

            {isFluencyLocked && (
              <svg
                className="absolute left-[42%] z-10 top-[40%]"
                xmlns="http://www.w3.org/2000/svg"
                width="9em"
                height="9em"
                viewBox="0 0 24 24"
              >
                <path
                  fill="currentColor"
                  d="M6.616 21q-.667 0-1.141-.475T5 19.386v-8.77q0-.666.475-1.14T6.615 9H8V7q0-1.671 1.165-2.835Q10.329 3 12 3t2.836 1.165T16 7v2h1.385q.666 0 1.14.475t.475 1.14v8.77q0 .666-.475 1.14t-1.14.475zM12 16.5q.633 0 1.066-.434q.434-.433.434-1.066t-.434-1.066T12 13.5t-1.066.434Q10.5 14.367 10.5 15t.434 1.066q.433.434 1.066.434M9 9h6V7q0-1.25-.875-2.125T12 4t-2.125.875T9 7z"
                ></path>
              </svg>
            )}
            <div
              style={{
                background: `url("/gradient-blue.png")`,
                backgroundRepeat: "no-repeat",
                backgroundPosition: "center",
              }}
              className={cn("h-full min-h-[250px] sm:min-h-[300px] lg:min-h-[500px] flex flex-col items-center justify-between py-4 sm:py-6 lg:py-10 lg:!bg-contain bg-cover rounded-xl", isFluencyLocked && "grayscale blur-sm brightness-75 opacity-80")}
            >
              <div className="flex flex-col flex-grow justify-center items-center px-4">
                <svg
                  width="198"
                  height="198"
                  className="w-12 h-12 sm:w-16 sm:h-16 md:w-24 md:h-24 lg:w-32 lg:h-32 xl:w-[196px] xl:h-[196px]"
                  viewBox="0 0 198 198"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M99 166.939L173.25 156.333V32.8309L101.623 43.065C99.8833 43.3134 98.1167 43.3134 96.3765 43.065L24.75 32.8309V156.333L99 166.939ZM26.4949 20.5796L98.1214 30.8138C98.7041 30.8974 99.2959 30.8974 99.8786 30.8138L171.505 20.5796C173.26 20.3297 175.048 20.4597 176.748 20.9607C178.448 21.4618 180.021 22.3223 181.36 23.4839C182.699 24.6456 183.773 26.0813 184.508 27.6939C185.244 29.3065 185.625 31.0583 185.625 32.8309V156.333C185.625 159.313 184.55 162.193 182.597 164.443C180.644 166.694 177.945 168.164 174.995 168.585L99.8786 179.314C99.2959 179.397 98.7041 179.397 98.1214 179.314L23.0051 168.585C20.0552 168.164 17.3558 166.694 15.403 164.443C13.4502 162.193 12.375 159.313 12.375 156.333V32.8309C12.375 31.0583 12.7558 29.3065 13.4916 27.6939C14.2274 26.0813 15.3011 24.6456 16.6399 23.4839C17.9788 22.3223 19.5515 21.4618 21.2518 20.9607C22.952 20.4597 24.74 20.3297 26.4949 20.5796Z"
                    fill="#6948B1"
                  />
                  <path
                    d="M92.8125 37.125H105.188V173.25H92.8125V37.125Z"
                    fill="#6948B1"
                  />
                </svg>
                <p className="text-sm sm:text-lg md:text-2xl lg:text-3xl xl:text-4xl font-bold text-purple-900 text-center">
                  Reading Fluency
                </p>
                <p className="text-xs sm:text-base md:text-lg font-medium text-center">{fluency}</p>
              </div>
              <button className=" bg-[#6948B1] px-3 sm:px-4 py-2 sm:py-2 md:py-3 rounded-xl sm:rounded-2xl text-white text-sm sm:text-base md:text-xl lg:text-2xl font-medium flex items-center justify-between gap-2 sm:gap-4 shadow-md shadow-[#A47C7C]">
                <span className="font-bold">Continue</span>
                <svg
                  className="w-2 h-3 md:w-4 md:h-5"
                  viewBox="0 0 13 22"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M8.15 11L0.675001 3.52499C0.323612 3.1736 0.147919 2.72638 0.147919 2.18332C0.147919 1.64027 0.323612 1.19305 0.675001 0.841658C1.02639 0.490269 1.47361 0.314575 2.01667 0.314575C2.55972 0.314575 3.00695 0.490269 3.35834 0.841658L12.175 9.65833C12.3667 9.84999 12.5028 10.0576 12.5833 10.2812C12.6638 10.5049 12.7034 10.7444 12.7021 11C12.7021 11.2555 12.6625 11.4951 12.5833 11.7187C12.504 11.9424 12.3679 12.15 12.175 12.3417L3.35834 21.1583C3.00695 21.5097 2.55972 21.6854 2.01667 21.6854C1.47361 21.6854 1.02639 21.5097 0.675001 21.1583C0.323612 20.8069 0.147919 20.3597 0.147919 19.8167C0.147919 19.2736 0.323612 18.8264 0.675001 18.475L8.15 11Z"
                    fill="white"
                  />
                </svg>
              </button>
            </div>
          </div>
        )}

        <div
          className={`w-full flex-1 relative cursor-pointer min-h-[250px] sm:min-h-[300px] lg:min-h-[500px] ${isLibraryOnlyLicense ? 'lg:max-w-2xl lg:mx-auto' : ''}`}
          onClick={() => {
            if (grade && canTakeLibrary) {
              onNext("library");
            } else {
              setModalType('library');
              setOpenModal(true);
            }
          }}
        >

          {/* Library lock overlay - shows clock for quiz lock, lock icon for lesson 28 lock */}
          {!canTakeLibrary && grade && (
            <div className="absolute left-[42%] z-10 top-[40%] bg-white rounded-full p-3 shadow-lg">
              {libraryLockReason === 'lesson28' ? (
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="5em"
                  height="5em"
                  viewBox="0 0 24 24"
                  className="text-red-500"
                >
                  <path
                    fill="currentColor"
                    d="M6.616 21q-.667 0-1.141-.475T5 19.386v-8.77q0-.666.475-1.14T6.615 9H8V7q0-1.671 1.165-2.835Q10.329 3 12 3t2.836 1.165T16 7v2h1.385q.666 0 1.14.475t.475 1.14v8.77q0 .666-.475 1.14t-1.14.475zM12 16.5q.633 0 1.066-.434q.434-.433.434-1.066t-.434-1.066T12 13.5t-1.066.434Q10.5 14.367 10.5 15t.434 1.066q.433.434 1.066.434M9 9h6V7q0-1.25-.875-2.125T12 4t-2.125.875T9 7z"
                  />
                </svg>
              ) : (
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="5em"
                  height="5em"
                  viewBox="0 0 24 24"
                  className="text-orange-500"
                >
                  <path
                    fill="currentColor"
                    d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm.5-13H11v6l5.25 3.15.75-1.23-4.5-2.67V7z"
                  />
                </svg>
              )}
            </div>
          )}
          <div
            style={{
              background: `url("/gradient-library.png")`,
              backgroundRepeat: "no-repeat",
              backgroundPosition: "center",
            }}
            className={cn(
              "h-full min-h-[250px] sm:min-h-[300px] lg:min-h-[500px] flex flex-col items-center justify-between py-4 sm:py-6 lg:py-10 lg:!bg-contain bg-cover relative rounded-xl",
              !canTakeLibrary && libraryLockReason === 'lesson28' && "grayscale blur-sm brightness-75 opacity-80",
            )}
          >
            {/* <div className="flex-1 h-[800px] p-8 rounded-[40px] flex flex-col justify-between items-center gradient-orange shadow-lg"> */}
            <div className="flex flex-col items-center justify-center w-full px-2 sm:px-4">
              <h3 className="text-sm sm:text-lg md:text-2xl lg:text-3xl xl:text-4xl font-bold text-center">
                <span className="text-[#1A588A]">Welcome To </span>
                <span className="text-[#1A588A]">Read </span>
                <span className="text-[#439C56]">21</span>
              </h3>
            </div>

            <div className="w-12 h-12 sm:w-16 sm:h-16 md:w-24 md:h-24 lg:w-32 lg:h-32 xl:w-36 xl:h-36 flex items-center justify-center mb-1 sm:mb-2 md:mb-3">

              <img src="/library.png" alt="Gold Gradient" className="w-full h-auto " />


              {/* <svg className="w-full h-full" viewBox="0 0 226 216" fill="none">
                  <rect x="20" y="40" width="180" height="140" rx="10" fill="#3D74B6" stroke="#374957" strokeWidth="2"/>
                  <rect x="30" y="50" width="160" height="100" fill="white"/>
                  <rect x="40" y="60" width="30" height="80" fill="#4A90E2"/>
                  <rect x="80" y="60" width="30" height="80" fill="#4A90E2"/>
                  <rect x="120" y="60" width="30" height="80" fill="#4A90E2"/>
                  <rect x="160" y="60" width="20" height="80" fill="#4A90E2"/>
                  <circle cx="113" cy="200" r="15" fill="#B4E50D"/>
                </svg> */}
            </div>

            {/* <div className="rounded-3xl flex flex-col items-center justify-center w-full text-center relative"> */}
            <div className="rounded-2xl sm:rounded-3xl flex flex-col items-center justify-center w-full max-w-xs sm:max-w-sm mx-auto text-center relative p-2 sm:p-3 md:p-4 bg-white/10 shadow-lg">
              <h4 className="text-sm sm:text-lg md:text-xl lg:text-2xl font-bold text-[#374957] mb-1 md:mb-2">Online Library</h4>
              {/* <div className="flex items-center justify-center gap-2 mt-2">
                  <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g clip-path="url(#clip0_254_943)">
                      <path d="M19 2.4319C18.5315 2.04018 17.9825 1.75639 17.392 1.60071C16.8015 1.44502 16.184 1.42124 15.5833 1.53107L12.3983 2.1094C11.663 2.24444 10.9944 2.62276 10.5 3.18357C10.0043 2.62179 9.33377 2.24338 8.59664 2.1094L5.41664 1.53107C4.81593 1.42115 4.19841 1.44461 3.60778 1.5998C3.01715 1.75499 2.46786 2.03811 1.99877 2.42911C1.52969 2.82012 1.15229 3.30946 0.893288 3.86249C0.634285 4.41552 0.50001 5.01873 0.499969 5.6294L0.499969 14.6236C0.500017 15.5992 0.84245 16.5439 1.46758 17.293C2.09271 18.0421 2.96089 18.5481 3.9208 18.7227L9.15914 19.6752C10.0458 19.8363 10.9542 19.8363 11.8408 19.6752L17.0833 18.7227C18.0424 18.5472 18.9097 18.0409 19.534 17.2919C20.1583 16.5429 20.5001 15.5986 20.5 14.6236V5.6294C20.5003 5.01894 20.3661 4.4159 20.1069 3.86323C19.8476 3.31056 19.4697 2.82185 19 2.4319V2.4319ZM9.66664 18.0694C9.59664 18.0594 9.52664 18.0477 9.45664 18.0352L4.21914 17.0836C3.64311 16.9788 3.12213 16.6751 2.74704 16.2256C2.37195 15.776 2.16655 15.2091 2.16664 14.6236V5.6294C2.16664 4.96636 2.43003 4.33048 2.89887 3.86164C3.36771 3.39279 4.0036 3.1294 4.66664 3.1294C4.81754 3.12976 4.96813 3.14343 5.11664 3.17024L8.29997 3.75357C8.68298 3.82365 9.02936 4.02563 9.27901 4.32444C9.52865 4.62325 9.66579 5.00003 9.66664 5.3894V18.0694ZM18.8333 14.6236C18.8334 15.2091 18.628 15.776 18.2529 16.2256C17.8778 16.6751 17.3568 16.9788 16.7808 17.0836L11.5433 18.0352C11.4733 18.0477 11.4033 18.0594 11.3333 18.0694V5.3894C11.3332 4.99908 11.4702 4.62111 11.7202 4.32141C11.9703 4.0217 12.3176 3.81927 12.7016 3.7494L15.8858 3.16607C16.2464 3.10046 16.617 3.11494 16.9714 3.20849C17.3258 3.30204 17.6553 3.47237 17.9365 3.70741C18.2177 3.94244 18.4438 4.23645 18.5988 4.56859C18.7538 4.90073 18.8338 5.26288 18.8333 5.6294V14.6236Z" fill="#374957" />
                    </g>
                    <defs>
                      <clipPath id="clip0_254_943">
                        <rect width="20" height="20" fill="white" transform="translate(0.499969 0.629395)" />
                      </clipPath>
                    </defs>
                  </svg>

                  <span className="text-xl text-[#374957]">Doing Your Best</span>
                </div> */}


              <div className="flex flex-wrap justify-center gap-2 sm:gap-3 md:gap-4 lg:gap-5 mb-2 w-full">
                {[1, 2, 3, 4, 5, 6, 7, 8].map((d) => {
                  return (
                    <div className={
                      d === 6 && grade < 9 && grade >= 6
                        ? "w-6 h-6 sm:w-8 sm:h-8 md:w-10 md:h-10 lg:w-12 lg:h-12 bg-gradient-to-b  from-[#3D74B6] to-[#3D74B6] rounded-full flex items-center justify-center"
                        : grade >= 9 && d === 7
                          ? "w-6 h-6 sm:w-8 sm:h-8 md:w-10 md:h-10 lg:w-12 lg:h-12 bg-gradient-to-b  from-[#3D74B6] to-[#3D74B6] rounded-full flex items-center justify-center"
                          : d === grade && grade <= 5
                            ? "w-6 h-6 sm:w-8 sm:h-8 md:w-10 md:h-10 lg:w-12 lg:h-12 bg-gradient-to-b  from-[#3D74B6] to-[#3D74B6] rounded-full flex items-center justify-center"
                            : "w-6 h-6 sm:w-8 sm:h-8 md:w-10 md:h-10 lg:w-12 lg:h-12 bg-gradient-to-b  from-[#B4E50D] to-[#78C841] rounded-full flex items-center justify-center"
                    }>
                      <span className={`font-medium text-xs sm:text-sm md:text-base lg:text-lg ${d === 6 && grade < 9 && grade >= 6
                        ? "text-white"
                        : grade >= 9 && d === 7
                          ? "text-white"
                          : d === grade && grade <= 5
                            ? "text-white"
                            : "text-[#374957]"
                        } `}>
                        {/* {d < 6 ? `G${d}` : d === 6 ? "MS" : "HS"} */}
                        {`G${d}`}
                      </span>
                    </div>
                  );
                })}
                {/* <div className="w-20 h-20 bg-gradient-to-b from-[#B4E50D] to-[#78C841] rounded-full flex items-center justify-center">
                  <span className="text-[#374957] font-medium text-xl">1st</span>
                </div>
                <div className="w-[91px] h-[91px] bg-[#3D74B6] rounded-full flex items-center justify-center">
                  <span className="text-white font-medium text-2xl">2nd</span>
                </div>
                <div className="w-20 h-20 bg-gradient-to-b from-[#B4E50D] to-[#78C841] rounded-full flex items-center justify-center">
                  <span className="text-[#374957] font-medium text-xl">3rd</span>
                </div>
                <div className="w-20 h-20 bg-gradient-to-b from-[#B4E50D] to-[#78C841] rounded-full flex items-center justify-center">
                  <span className="text-[#374957] font-medium text-xl">4th</span>
                </div>
                <div className="w-20 h-20 bg-gradient-to-b from-[#B4E50D] to-[#78C841] rounded-full flex items-center justify-center">
                  <span className="text-[#374957] font-medium text-xl">5th</span>
                </div>
                <div className="w-20 h-20 bg-gradient-to-b from-[#B4E50D] to-[#78C841] rounded-full flex items-center justify-center">
                  <span className="text-[#374957] font-medium text-xl">6th</span>
                </div>
                <div className="w-20 h-20 bg-gradient-to-b from-[#B4E50D] to-[#78C841] rounded-full flex items-center justify-center">
                  <span className="text-[#374957] font-medium text-xl">7th</span>
                </div>
                <div className="w-20 h-20 bg-gradient-to-b from-[#B4E50D] to-[#78C841] rounded-full flex items-center justify-center">
                  <span className="text-[#374957] font-medium text-xl">8th</span>
                </div> */}
              </div>
            </div>

            <button onClick={() => {
              if (grade && canTakeLibrary) {
                navigate('/libraryIntro');
              } else {
                setModalType('library');
                setOpenModal(true);
              }
            }} className=" bg-[#3D74B6] px-3 sm:px-4 py-2 sm:py-2 md:py-3 rounded-xl sm:rounded-2xl text-white text-sm sm:text-base md:text-xl lg:text-2xl font-medium flex items-center justify-between gap-2 sm:gap-4 shadow-md shadow-[#A47C7C]">
              <span className="font-bold">Continue</span>
              <svg
                className="w-2 h-3 md:w-4 md:h-5"
                viewBox="0 0 13 22"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M8.15 11L0.675001 3.52499C0.323612 3.1736 0.147919 2.72638 0.147919 2.18332C0.147919 1.64027 0.323612 1.19305 0.675001 0.841658C1.02639 0.490269 1.47361 0.314575 2.01667 0.314575C2.55972 0.314575 3.00695 0.490269 3.35834 0.841658L12.175 9.65833C12.3667 9.84999 12.5028 10.0576 12.5833 10.2812C12.6638 10.5049 12.7034 10.7444 12.7021 11C12.7021 11.2555 12.6625 11.4951 12.5833 11.7187C12.504 11.9424 12.3679 12.15 12.175 12.3417L3.35834 21.1583C3.00695 21.5097 2.55972 21.6854 2.01667 21.6854C1.47361 21.6854 1.02639 21.5097 0.675001 21.1583C0.323612 20.8069 0.147919 20.3597 0.147919 19.8167C0.147919 19.2736 0.323612 18.8264 0.675001 18.475L8.15 11Z"
                  fill="white"
                />
              </svg>
            </button>
            {/* <button
                onClick={() => navigate('/library-entrance')}
                className="w-full md:w-1/2 py-3 md:py-4 bg-[#3D74B6] text-white rounded-3xl text-xl md:text-2xl font-bold shadow-button hover:bg-[#2d5a94] transition-all"
              >
                Continue
              </button> */}
            {/* </div> */}
          </div>
        </div>

        {!isLibraryOnlyLicense && (
          <div
            className="w-full flex-1 relative cursor-pointer min-h-[250px] sm:min-h-[300px] lg:min-h-[500px]"
            onClick={() => {
              if (grade && allowCt && canTakeCT) {
                onNext("critical");
              } else {
                setModalType('ct');
                setOpenModal(true);
              }
            }}
          >
            {allowCt && !canTakeCT && (
              <div className="absolute left-[42%] z-10 top-[40%] bg-white rounded-full p-3 shadow-lg">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="5em"
                  height="5em"
                  viewBox="0 0 24 24"
                  className="text-orange-500"
                >
                  <path
                    fill="currentColor"
                    d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm.5-13H11v6l5.25 3.15.75-1.23-4.5-2.67V7z"
                  />
                </svg>
              </div>
            )}
            <div
              style={{
                background: `url("/gradient-gold.png")`,
                backgroundRepeat: "no-repeat",
                backgroundPosition: "center",
              }}
              className={cn(
                "h-full min-h-[250px] sm:min-h-[300px] lg:min-h-[500px] flex flex-col items-center justify-between py-4 sm:py-6 lg:py-10 lg:!bg-contain bg-cover relative rounded-xl",
                !allowCt && "grayscale blur-sm brightness-75 opacity-80",
              )}
            >
              <div className="flex relative flex-col flex-grow justify-center items-center px-2 sm:px-4">
                <svg
                  className="w-12 h-12 sm:w-16 sm:h-16 md:w-24 md:h-24 lg:w-32 lg:h-32 xl:w-[196px] xl:h-[196px]"
                  viewBox="0 0 196 196"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M58.408 24.598C65.2027 19.306 74.088 16.3823 82.9162 16.3823C88.2 16.3823 92.4712 18.1953 95.7133 21.0782C96.5872 21.854 97.363 22.6952 98.0572 23.5608C98.7513 22.6952 99.5272 21.854 100.401 21.0782C103.643 18.1953 107.914 16.3823 113.198 16.3823C122.026 16.3823 130.92 19.306 137.698 24.598C142.99 28.7058 147.131 34.3817 148.756 41.2335C152.186 41.8052 155.232 43.5528 157.698 45.864C161.618 49.5472 164.419 54.8718 166.175 60.3517C167.964 65.9132 168.854 72.1607 168.585 78.1632C168.446 81.2338 167.997 84.3698 167.139 87.367L167.67 87.612C170.691 89.033 173.142 91.2625 174.979 94.227C178.45 99.8212 179.675 107.873 179.675 118.139C179.675 129.94 175.159 137.951 169.36 142.925C166.34 145.515 162.805 147.436 158.989 148.56C157.604 154.942 154.758 160.915 150.675 166.012C144.771 173.395 135.591 179.634 123.26 179.634C113.378 179.634 105.595 174.162 100.597 168.936C99.7106 168.002 98.8659 167.029 98.0653 166.02C97.2619 167.026 96.4145 167.996 95.5255 168.927C90.5275 174.17 82.7447 179.634 72.863 179.634C60.5232 179.634 51.3438 173.395 45.4475 166.012C41.3583 160.917 38.5069 154.943 37.1175 148.56C33.3037 147.435 29.7716 145.514 26.754 142.925C20.9557 137.943 16.4477 129.94 16.4477 118.139C16.4477 107.873 17.6727 99.8212 21.1353 94.227C22.9725 91.1813 25.7127 88.7836 28.9753 87.367C28.1363 84.3659 27.6511 81.277 27.5298 78.1632C27.2603 72.1607 28.1505 65.9132 29.939 60.3517C31.6948 54.88 34.4878 49.5472 38.416 45.864C40.8728 43.4693 43.985 41.8578 47.3585 41.2335C48.9918 34.3735 53.1242 28.7058 58.408 24.598ZM65.9377 34.2592C61.4787 37.73 58.8653 42.3523 58.8653 47.677C58.8646 48.647 58.6335 49.6029 58.191 50.4662C57.7486 51.3294 57.1074 52.0752 56.3204 52.6421C55.5333 53.2091 54.6229 53.581 53.664 53.7273C52.7051 53.8736 51.7251 53.79 50.8048 53.4835C49.686 53.1078 48.5018 53.1977 46.8032 54.7983C44.9085 56.5705 42.9893 59.78 41.601 64.092C40.2122 68.4599 39.5932 73.036 39.7717 77.616C39.9758 82.1567 41.0538 85.9296 42.7525 88.4777C43.0336 88.8998 43.2612 89.3552 43.4303 89.8333H52.2667C58.1464 89.8321 63.8087 92.0562 68.1157 96.0587C72.4228 100.061 75.0554 105.546 75.4845 111.41C79.0026 112.813 81.9234 115.396 83.747 118.716C85.5707 122.036 86.1838 125.887 85.4814 129.609C84.779 133.331 82.8048 136.693 79.8967 139.12C76.9886 141.547 73.3274 142.888 69.5397 142.913C65.752 142.938 62.0733 141.646 59.1332 139.258C56.1932 136.87 54.1746 133.534 53.4228 129.821C52.6711 126.109 53.2331 122.251 55.0125 118.907C56.7919 115.563 59.6782 112.942 63.1773 111.491C62.7894 108.875 61.4741 106.486 59.4712 104.759C57.4683 103.032 54.9113 102.082 52.2667 102.083H30.8292C29.6042 104.925 28.6977 109.833 28.6977 118.139C28.6977 126.477 31.7275 131.05 34.7328 133.631C38.024 136.449 41.6418 137.184 42.6872 137.184C44.3116 137.184 45.8695 137.829 47.0182 138.978C48.1669 140.126 48.8122 141.684 48.8122 143.309C48.8122 146.739 50.7068 152.97 55.0188 158.36C59.1675 163.562 65.0802 167.384 72.863 167.384C78.0652 167.384 82.8508 164.46 86.6647 160.475C88.5103 158.531 89.9477 156.514 90.895 154.881C91.2535 154.27 91.5674 153.634 91.8342 152.978L91.8832 152.864V75.5417H84.5658C83.1444 79.0555 80.5451 81.9656 77.2134 83.7732C73.8818 85.5807 70.0251 86.1733 66.3045 85.4492C62.5838 84.7252 59.2308 82.7297 56.8201 79.8046C54.4094 76.8795 53.0911 73.2071 53.0911 69.4167C53.0911 65.6262 54.4094 61.9538 56.8201 59.0287C59.2308 56.1037 62.5838 54.1081 66.3045 53.3841C70.0251 52.66 73.8818 53.2526 77.2134 55.0602C80.5451 56.8677 83.1444 59.7778 84.5658 63.2917H91.8832V42.5647L91.8587 42.0992C91.7189 39.584 91.224 37.1012 90.3887 34.7247C89.6537 32.7647 88.6982 31.2375 87.5712 30.233C86.5667 29.3347 85.1783 28.6323 82.9162 28.6323C76.6605 28.6323 70.462 30.7393 65.9295 34.2673M104.239 138.833V152.864L104.28 152.978C104.443 153.411 104.754 154.056 105.228 154.881C106.167 156.514 107.604 158.531 109.458 160.475C113.263 164.46 118.057 167.384 123.26 167.384C131.034 167.384 136.947 163.562 141.104 158.36C145.408 152.97 147.31 146.73 147.31 143.309C147.31 141.684 147.956 140.126 149.104 138.978C150.253 137.829 151.811 137.184 153.435 137.184C154.481 137.184 158.09 136.449 161.39 133.631C164.387 131.05 167.417 126.477 167.417 118.139C167.417 108.274 166.126 103.194 164.566 100.687C164.078 99.8198 163.338 99.1219 162.443 98.686C161.618 98.294 160.377 98 158.458 98C157.349 97.9999 156.262 97.699 155.311 97.1293C154.36 96.5596 153.581 95.7424 153.058 94.765C152.535 93.7876 152.287 92.6866 152.34 91.5793C152.394 90.4721 152.747 89.4001 153.362 88.4777C155.061 85.9296 156.139 82.1567 156.351 77.616C156.526 73.0356 155.905 68.4595 154.513 64.092C153.125 59.78 151.206 56.5787 149.319 54.7983C147.613 53.1977 146.428 53.1078 145.318 53.4835C144.397 53.7916 143.416 53.8764 142.456 53.7309C141.496 53.5854 140.584 53.2137 139.796 52.6466C139.008 52.0794 138.366 51.333 137.923 50.469C137.48 49.6049 137.249 48.6479 137.249 47.677C137.249 42.3523 134.636 37.73 130.177 34.2592C125.66 30.7393 119.454 28.6242 113.19 28.6242C110.936 28.6242 109.556 29.3347 108.543 30.2248C107.265 31.4787 106.302 33.0181 105.734 34.7165C104.818 37.2355 104.313 39.8854 104.239 42.5647V126.583H109.433C112.357 126.583 115.162 125.422 117.229 123.354C119.297 121.287 120.458 118.482 120.458 115.558V100.899C116.944 99.4777 114.034 96.8785 112.227 93.5468C110.419 90.2151 109.827 86.3585 110.551 82.6378C111.275 78.9171 113.27 75.5642 116.195 73.1535C119.12 70.7427 122.793 69.4244 126.583 69.4244C130.374 69.4244 134.046 70.7427 136.971 73.1535C139.896 75.5642 141.892 78.9171 142.616 82.6378C143.34 86.3585 142.747 90.2151 140.94 93.5468C139.132 96.8785 136.222 99.4777 132.708 100.899V115.558C132.708 121.731 130.256 127.651 125.891 132.016C121.526 136.381 115.606 138.833 109.433 138.833H104.239ZM69.4167 65.3333C68.3337 65.3333 67.2951 65.7635 66.5293 66.5293C65.7635 67.2951 65.3333 68.3337 65.3333 69.4167C65.3333 70.4996 65.7635 71.5382 66.5293 72.304C67.2951 73.0698 68.3337 73.5 69.4167 73.5C70.4996 73.5 71.5382 73.0698 72.304 72.304C73.0698 71.5382 73.5 70.4996 73.5 69.4167C73.5 68.3337 73.0698 67.2951 72.304 66.5293C71.5382 65.7635 70.4996 65.3333 69.4167 65.3333ZM65.3333 126.583C65.3333 127.666 65.7635 128.705 66.5293 129.471C67.2951 130.236 68.3337 130.667 69.4167 130.667C70.4996 130.667 71.5382 130.236 72.304 129.471C73.0698 128.705 73.5 127.666 73.5 126.583C73.5 125.5 73.0698 124.462 72.304 123.696C71.5382 122.93 70.4996 122.5 69.4167 122.5C68.3337 122.5 67.2951 122.93 66.5293 123.696C65.7635 124.462 65.3333 125.5 65.3333 126.583ZM122.5 85.75C122.5 86.833 122.93 87.8716 123.696 88.6373C124.462 89.4031 125.5 89.8333 126.583 89.8333C127.666 89.8333 128.705 89.4031 129.471 88.6373C130.236 87.8716 130.667 86.833 130.667 85.75C130.667 84.667 130.236 83.6284 129.471 82.8626C128.705 82.0969 127.666 81.6667 126.583 81.6667C125.5 81.6667 124.462 82.0969 123.696 82.8626C122.93 83.6284 122.5 84.667 122.5 85.75Z"
                    fill="#FFA800"
                  />
                </svg>
                <p className="text-sm sm:text-lg md:text-2xl lg:text-3xl xl:text-4xl font-bold text-gold-900 text-center">
                  Critical Thinking
                </p>
                <p className="text-xs sm:text-base md:text-lg font-medium text-center">{ct || "Not Started"}</p>
                <div className="flex items-center gap-1 sm:gap-2 md:gap-3 justify-center mt-2 sm:mt-4 md:mt-6">
                  {[2, 3, 4, 5, 6, 7].map((d) => {
                    return (
                      <div
                        className={cn(
                          "w-5 h-5 sm:w-6 sm:h-6 md:w-8 md:h-8 lg:w-10 lg:h-10 bg-white border-2 border-yellow-400 rounded-full flex items-center justify-center font-bold text-gray-400",
                          d === 6 && grade < 9 && grade >= 6
                            ? "bg-yellow-500 text-white"
                            : grade >= 9 && d === 7
                              ? "bg-yellow-500 text-white"
                              : d === grade && grade <= 5
                                ? "bg-yellow-500 text-white"
                                : "",
                        )}
                      >
                        <span className="text-xs sm:text-xs md:text-sm">{d < 6 ? `G${d}` : d === 6 ? "MS" : "HS"}</span>
                      </div>
                    );
                  })}
                </div>
              </div>
              <button className=" bg-[#FFA800] px-3 sm:px-4 py-2 sm:py-2 md:py-3 rounded-xl sm:rounded-2xl text-white text-sm sm:text-base md:text-xl lg:text-2xl font-medium flex items-center justify-between gap-2 sm:gap-4 shadow-md shadow-[#A47C7C]">
                <span className="font-bold">Continue</span>
                <svg
                  className="w-2 h-3 md:w-4 md:h-5"
                  viewBox="0 0 13 22"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M8.15 11L0.675001 3.52499C0.323612 3.1736 0.147919 2.72638 0.147919 2.18332C0.147919 1.64027 0.323612 1.19305 0.675001 0.841658C1.02639 0.490269 1.47361 0.314575 2.01667 0.314575C2.55972 0.314575 3.00695 0.490269 3.35834 0.841658L12.175 9.65833C12.3667 9.84999 12.5028 10.0576 12.5833 10.2812C12.6638 10.5049 12.7034 10.7444 12.7021 11C12.7021 11.2555 12.6625 11.4951 12.5833 11.7187C12.504 11.9424 12.3679 12.15 12.175 12.3417L3.35834 21.1583C3.00695 21.5097 2.55972 21.6854 2.01667 21.6854C1.47361 21.6854 1.02639 21.5097 0.675001 21.1583C0.323612 20.8069 0.147919 20.3597 0.147919 19.8167C0.147919 19.2736 0.323612 18.8264 0.675001 18.475L8.15 11Z"
                    fill="white"
                  />
                </svg>
              </button>
            </div>
          </div>
        )}
      </div>
      {openModal && (
        <Modal className="" close={() => setOpenModal(false)}>
          <div className="bg-white rounded-2xl px-10 py-4">
            {(modalType === 'ct' && !canTakeCT && allowCt) || (modalType === 'library' && !canTakeLibrary) ? (
              <div className="flex flex-col items-center justify-center p-8">
                <div className="mb-6">
                  <img
                    src="/images/alarm_clock.jpg"
                    alt="Alarm Clock"
                    className="w-32 h-32 mx-auto"
                  />
                </div>
                <div className="bg-gray-100 rounded-2xl p-6 text-center max-w-md">
                  <h2 className="text-3xl font-bold text-gray-800 mb-4">
                    {modalType === 'ct'
                      ? 'SEE YOU TOMORROW FOR YOUR NEXT LESSON.'
                      : libraryLockReason === 'lesson28'
                        ? 'COMPLETE FLUENCY TO ACCESS THE LIBRARY.'
                        : 'COME BACK AFTER 4 HOURS.'}
                  </h2>
                </div>
                <Button
                  className="mt-6"
                  onClick={() => setOpenModal(false)}
                  background="blue"
                  title="OK"
                />
              </div>
            ) : (
              <div>
                <div className="flex items-center justify-center">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="text-red-600"
                    width="3em"
                    height="3em"
                    viewBox="0 0 24 24"
                  >
                    <path
                      fill="currentColor"
                      d="m12 13.4l-4.9 4.9q-.275.275-.7.275t-.7-.275t-.275-.7t.275-.7l4.9-4.9l-4.9-4.9q-.275-.275-.275-.7t.275-.7t.7-.275t.7.275l4.9 4.9l4.9-4.9q.275-.275.7-.275t.7.275t.275.7t-.275.7L13.4 12l4.9 4.9q.275.275.275.7t-.275.7t-.7.275t-.7-.275z"
                    ></path>
                  </svg>
                  <p className="text-3xl text-red-700 font-bold">Access Denied</p>
                </div>
                <p className="text-2xl text-black break-words max-w-screen-sm mt-3 text-center">
                  Complete Reading Fluency or have Teacher Unlock.
                </p>
                <div className="flex justify-center mt-4">
                  <Button
                    onClick={() => {
                      onNext("fluency");
                    }}
                    contentSize="medium"
                    title="Continue to Reading Fluency"
                    icon={"nextBack"}
                  />
                </div>
              </div>
            )}
          </div>
        </Modal>

      )}

    </div>
  );
};

export default ModuleChoice;
